export function getPortfolioKiosks() {
  return [
    {
      link: '',
      image: './gifs-kiosk/kiosk-blacktown.gif',
      title: 'Blacktown Workers Club',
      classname: 'kiosk-blacktown',
      logo: './gifs-kiosk/logo/logo-workers.jpg',
      thumbnailStyles: { 'paddingLeft': '20%', 'backgroundColor': '#fff', 'borderBottom': '1px solid #eaeaea', 'justifyContent': 'flex-start' },
      year: '2023',
      roles: [{ title: 'Fullstack', skills: 'NodeJS, React, Express, Postgres' }]
    },
    {
      link: '',
      image: './gifs-kiosk/kiosk-merrylands.gif',
      title: 'Merrylands RSL',
      classname: 'kiosk-merrylands',
      logo: './gifs-kiosk/logo/logo-msrl.jpg',
      thumbnailStyles: { 'paddingLeft': '20%', 'backgroundColor': '#fff', 'borderBottom': '1px solid #eaeaea', 'justifyContent': 'flex-start' },
      year: '2022 - 2023',
      roles: [{ title: 'Fullstack', skills: 'NodeJS, React, Express, Postgres' }]
    },
    {
      link: '',
      image: './gifs-kiosk/kiosk-nustar.gif',
      title: 'Nustar Cebu Resort',
      classname: 'kiosk-nustar',
      logo: './gifs-kiosk/logo/logo-nustar.jpg',
      thumbnailStyles: { 'paddingLeft': '20%', 'backgroundColor': '#fff', 'borderBottom': '1px solid #eaeaea', 'justifyContent': 'flex-start' },
      year: '2023',
      roles: [{ title: 'Fullstack', skills: 'NodeJS, React, Express, Postgres' }]
    },
    {
      link: '',
      image: './gifs-kiosk/kiosk-terrigal.gif',
      title: 'Terrigal',
      classname: 'kiosk-terrigal',
      logo: './gifs-kiosk/logo/logo-terrigal.jpg',
      logoStyles: { 'height': '80px' },
      thumbnailStyles: { 'paddingLeft': '20%', 'backgroundColor': '#fff', 'borderBottom': '1px solid #eaeaea', 'justifyContent': 'flex-start' },
      year: '2023',
      roles: [{ title: 'Fullstack', skills: 'NodeJS, React, Express, Postgres' }]
    },
  ]
}

export function getPortfolioSlots() {
  return [
    {
      link: '',
      image: './gifs/bao-sun.gif',
      imageClass: 'h-anchor',
      thumbnailStyles: { 'backgroundColor': '#3C1D0B' },
      title: 'Bao Sun',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/cod.gif',
      imageClass: 'v-anchor',
      thumbnailStyles: { 'backgroundColor': '#8E6805' },
      title: 'City of Dreams Manila',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/crown.gif',
      imageClass: '',
      thumbnailStyles: { 'backgroundColor': '#141938' },
      imageStyles: { width: '100%', height: '200px', 'objectFit': 'cover', 'objectPosition': '45% 100%' },
      title: 'Crown Resorts',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/ettalong.gif',
      imageClass: '',
      thumbnailStyles: { 'backgroundColor': '#141938' },
      imageStyles: null,
      title: 'Ettalong bowling club',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/fairfield.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Fairfield RSL',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/hali.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Halekulani Bowling Club',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/hoiana.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#560343' },
      title: 'Hoiana',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/hotel-stotsenberg.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Hotel Stotsenberg Clark',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/itc.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#013C5C' },
      title: 'ITC',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/max.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#333' },
      title: 'Max',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/merrylands.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#10111D' },
      title: 'Merrylands RSL',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/mgm.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#745930' },
      title: 'MGM',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/milton.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Milton Club',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/mindil-beach.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#042423' },
      title: 'Mindil Beach',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/new-world.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#022301' },
      title: 'Casino Filipino',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/nustar.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#2E0F1D' },
      title: 'Nustar Cebu Resort',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/palazzo.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Palazzo Casino Resort',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/panthers.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Panthers Penrith Rugby Leagues Club',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/royce.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Royce',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/stations.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      thumbnailStyles: { 'backgroundColor': '#891608' },
      title: 'Stations Casino',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/wynn-macau.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Wynn Macau',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
    {
      link: '',
      image: './gifs/wynn-palace.gif',
      imageClass: 'v-anchor',
      imageStyles: null,
      title: 'Wynn Palace',
      year: ' ',
      roles: [
        {
          title: 'Frontend',
          skills: 'Html5, Vanilla JS, Css3, ElectronJS'
        }
      ]
    },
  ]
}

export function getPortfolio() {
  return [
    {
      link: 'https://grapl.it',
      title: 'Grapl',
      classname: 'grapl',
      year: '2021 - 2023',
      roles: [
        {
          title: 'Fullstack React Native Developer',
          skills: 'NodeJS, ExpressJS, MongoDB, Redis, Sockets, React Native, Laravel PHP, AWS Transcription, Jitsi, Twilio, Firebase,'
        }
      ]
    },
    {
      link: '',
      title: 'Bistro',
      classname: 'bistro',
      year: '2020 - 2022',
      roles: [
        {
          title: 'Fullstack',
          skills: 'NodeJS, ExpressJS, Mysql, ReactJS, Zustand, Html5, TailwindCss'
        }
      ]
    },
    {
      link: 'https://www.vitaledge.io',
      title: 'Vital Edge Web App',
      classname: 'vitaledge',
      year: '2023',
      roles: [
        {
          title: 'Frontend Developer',
          skills: 'ReactJS, Typescript, Emotion-React MUI, React-Query'
        }
      ]
    },
    {
      link: 'https://www.nomadplay.app/en',
      title: 'NomadPlay',
      classname: 'nomadplay',
      year: '2016 - 2017',
      roles: [
        {
          title: 'React Native Developer',
          skills: 'React Native'
        }
      ]
    },
    {
      link: 'https://fdi-claimly.herokuapp.com/',
      title: 'Flight Delayed Insurance',
      classname: 'claimly',
      year: '2016 - 2017',
      roles: [
        {
          title: 'Fullstack',
          skills: 'Ethereum Dapp, ReactJS'
        }
      ]
    },
    {
      link: 'https://theasiacollective.com',
      title: 'Asia Collective App',
      classname: 'asiacollective',
      year: '2020',
      roles: [
        {
          title: 'Fullstack',
          skills: 'NodeJS, ExpressJS, MySql, React Native, Firebase'
        }
      ]
    },
    {
      link: 'https://www.prosol-formation.fr/',
      title: 'Prosol Label Printing',
      classname: 'prosol',
      year: '2016',
      roles: [
        {
          title: 'Fullstack',
          skills: 'NodeJS, ExpressJS, MongoDB'
        }
      ]
    },
    {
      link: 'http://gigga.com/',
      title: 'Gigga Mobile App',
      classname: 'gigga',
      year: '2016',
      roles: [
        {
          title: 'Fullstack',
          skills: 'SOAP, React Native'
        }
      ]
    },
    {
      link: 'https://www.coverhero.com.au/',
      title: 'Coverhero',
      classname: 'coverhero',
      year: '2016',
      roles: [
        {
          title: 'Fullstack',
          skills: 'Express, NodeJS, PhantomJS, AWS, Heroku, Google Vision OCR, React Native, Mobx, Scraping',
        }
      ]
    },
    {
      link: 'https://www.dplusk.com.au/',
      title: 'D+K',
      classname: "dplusk",
      year: '2015',
      roles: [
        {
          title: 'Consultant',
          skills: 'ReactJS, HapiJS',
        }
      ]
    },

    {
      link: 'http://www.dentalonkennedy.com.au',
      title: 'Dental on Kennedy (WordPress)',
      classname: 'dentalonkennedy',
      year: '2015',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'CSS3, jQuery, WP'
        },
      ]
    },
    {
      link: 'http://thebeachfurniture.com.au',
      title: 'The Beach Furniture (WordPress)',
      classname: 'thebeachfrontfurniture',
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'CSS3, jQuery'
        },
      ]
    },
    {
      link: 'http://globalsupplements.com.au',
      title: 'Global Supplements (Magento)',
      classname: 'globalsupplements',
      year: '2015',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, Javascript, CSS3'
        },
        {
          title: 'Back End Developer',
          skills: 'Magento, Php'
        },
      ]
    },

    {
      link: "https://24hournutrition.com.au/",
      title: "24 Hour Nutrition",
      classname: 'twentyfourhournutrition',
      year: '2015',
      roles: [
        {
          title: 'Front End Developer',
          skills: "Javascript, CSS3"
        },
        {
          title: 'Back End Developer',
          skills: "Magento, Php",
        }
      ]
    },

    {
      link: 'http://thehotelbuyingoffice.com.au',
      title: 'The Hotel Buying Office (Magento)',
      classname: 'thehotelbuyingoffice',
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, CSS'
        },
      ]
    },
    {
      link: 'https://rsa-demo.herokuapp.com/',
      title: 'RSA IOS Mobile App',
      classname: 'regent-mobileapp',
      year: '2015',
      roles: [
        {
          title: 'Fullstack React Native Developer',
          skills: 'React Native, PHP, NODEJS',
        }
      ]
    },
    {
      link: 'http://rsaglobal.net.au',
      title: 'Regent Website',
      classname: 'regent',
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, CSS, WP, MYSQL'
        },
      ]
    },
    {
      link: '#',
      title: 'RSA Alarm Response App (Custom PHP Admin)',
      classname: 'rsaapp',
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, Javascript, CSS'
        },
        {
          title: 'Back End Developer',
          skills: 'PHP, MySql'
        },
      ]
    },
    {
      link: 'http://systemsandshelves.com',
      title: 'Systems and Shelves',
      classname: 'systemsandshelves',
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, Javascript, CSS, BS3'
        },
        {
          title: 'Backend End Developer',
          skills: 'Node, Express, Mongodb'
        },
      ]
    },
    {
      link: 'http://demo-koob.herokuapp.com/bookdrop',
      title: 'Systems and Shelves Book drop',
      classname: 'systemsandshelveskoob',
      year: '2015',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, CSS, JAVASCRIPT, BS3'
        },
        {
          title: 'Back End Developer',
          skills: 'Node, Express, Mongodb'
        },
      ]
    },
    {
      link: 'http://terranovaphotography.com.au',
      title: 'Terranova Photography',
      classname: 'terranova',
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, Javascript, CSS, WP'
        },
      ]
    },
    {
      link: 'https://indigenius-app.herokuapp.com/',
      type: 'project',
      classname: 'indigenius-app',
      year: '2014',
      roles: [
        {
          title: 'Fullstack Developer',
          skills: 'ReactJS, MongoDB, NodeJS'
        }
      ]
    },
    {
      link: 'https://newsupdate.herokuapp.com/',
      title: 'Update (News Scraper)',
      classname: 'project_updatecomph',
      type: "project",
      year: '2015',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'Reactjs, BS3'
        },
        {
          title: 'Backend End Developer',
          skills: 'Hapi.js, Nodejs, Socket.io, Express, MongoDB ',
        },
      ]
    },
    {
      link: 'https://livesoloist.bitbucket.io',
      title: 'Soloist (HTML Template)',
      classname: 'project_soloist',
      type: "project",
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, CSS, BS3'
        },
      ]
    },
    {
      link: '#',
      title: 'Tie knot (HTML Template)',
      classname: 'project_tieknot',
      type: "project",
      year: '2014',
      roles: [
        {
          title: 'Front End Developer',
          skills: 'HTML, CSS, BS3'
        },
      ]
    },
    {
      link: 'http://soundcloud-unofficial.herokuapp.com/',
      title: 'Soundcloud Unofficial App',
      classname: 'projectsoundcloud',
      type: "project",
      year: '2014',
      roles: [
        {
          title: 'App Developer',
          skills: 'Electron, NodeJS'
        },
      ]
    },


  ]
}



// WEBPACK FOOTER //
// ./src/data/portfolio.js